import { useEffect } from "react";
import { AppToasterV2, MultiStepItemProps } from "@ucl/library";
import { AccountDetailsForm } from "./AccountDetailsForm";
import { FinancialApplicationSection } from "@/types/enums";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { FinancialApplicationFormSectionContextType, useFinancialApplicationFormSectionValidation } from "@/hooks/useFinancialApplicationFormSectionValidation";

export interface AccountDetailsFormStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const AccountDetailsFormStep: React.FC<AccountDetailsFormStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <AccountDetailsFormStepInner {...props} />
    </RequireAuth>
  );
};

const AccountDetailsFormStepInner: React.FC<AccountDetailsFormStepProps> = (props) => {
  const { validateFinancialApplicationFormSection } = useFinancialApplicationFormSectionValidation(
    props.financialApplicationId,
    FinancialApplicationSection.AccountDetails
  );

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const { isValid } = await validateFinancialApplicationFormSection();

      if (!isValid) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
        return false;
      }
      return true;
    });
  }, [props.financialApplicationId, validateFinancialApplicationFormSection]);

  return (
    <section className="account-details step-section">
      <div className="account-details__header step-header">Account Details</div>
      <div className="account-details__subtitle step-subtitle">
        Please share the following account information so we can complete your setup smoothly.
      </div>

      <div className="account-details-form__content step-content">
        <AccountDetailsForm
          financialApplicationId={props.financialApplicationId}
          showHeader={true}
          validationContextType={FinancialApplicationFormSectionContextType.Applicant}
        />
      </div>
    </section>
  );
};
